const AllCategoryListReduser = (state = [], action) => {
    switch (action.type) {
        case 'GET_ROOT_CATEGORYS_FOR_MUFTI_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default AllCategoryListReduser